<template>
  <div class="col-md-6 pr-0">

    <!-- <div class="d-flex">
      <div class="col-md-6 pl-0" style="color: #004242; font-weight: 500;">
        <div class="pb-2">Employee Code:</div>
        <div class="py-2">Joining Date:</div>
        <div class="py-2">PF Enrollment Date:</div>
        <div class="py-2">Service Period:</div>
        <div class="py-2">PF Membership Period:</div>
        <div class="py-2">PF End Date:</div>
        <div class="pt-2">Closing Balance of PF:</div>
      </div>

      <div class="col-md-6 pl-0 pr-0">
        <div class="pb-2">{{ employee_pf_data.employee_code === null ? 'N/A' : employee_pf_data.employee_code }}</div> 
        <div class="py-2">{{ employee_pf_data.joining_date }}</div>
        <div class="py-2">{{ employee_pf_data.pf_start }}</div>
        <div class="py-2">{{ employee_pf_data.service_period }}</div>
        <div class="py-2">{{ employee_pf_data.membership_period }}</div>
        <div class="py-2">{{ employee_pf_data.pf_end }}</div>
        <div class="pt-2">{{ formatMoney(employee_pf_data.closing_balance) }}</div>
      </div>
    </div> -->

    <div class="d-flex py-2">
      <div class="col-md-6 pl-0" style="color:#004242;font-weight:500;">Employee Code:</div>
      <div class="col-md-6 pl-0 pr-0">{{ employee_pf_data.employee_code === null ? 'N/A' : employee_pf_data.employee_code }}</div> <!-- #bK-0004 issue solved -->
    </div>
    <div class="d-flex py-2">
        <div class="col-md-6 pl-0" style="color:#004242;font-weight:500;">Joining Date:</div>
        <div class="col-md-6 pl-0 pr-0">{{ employee_pf_data.joining_date }}</div>
    </div>
    <div class="d-flex py-2">
        <div class="col-md-6 pl-0" style="color:#004242;font-weight:500;">PF Enrollment Date:</div>
        <div class="col-md-6 pl-0 pr-0">{{ employee_pf_data.pf_start }}</div>
    </div>
    <div class="d-flex py-2">
        <div class="col-md-6 pl-0" style="color:#004242;font-weight:500;">Service Period:</div>
        <div class="col-md-6 pl-0 pr-0">{{ employee_pf_data.service_period }}</div>
    </div>
    <div class="d-flex py-2">
        <div class="col-md-6 pl-0" style="color:#004242;font-weight:500;">PF Membership Period:</div>
        <div class="col-md-6 pl-0 pr-0">{{ employee_pf_data.membership_period }}</div>
    </div>
    <div class="d-flex py-2">
        <div class="col-md-6 pl-0" style="color:#004242;font-weight:500;">PF End Date:</div>
        <div class="col-md-6 pl-0 pr-0">{{ employee_pf_data.pf_end }}</div>
    </div>
    <div class="d-flex py-2">
      <div class="col-md-6 pl-0" style="color:#004242;font-weight:500;">Closing Balance of PF:</div>
      <div class="col-md-6 pl-0 pr-0">{{ formatMoney(employee_pf_data.closing_balance) }}</div>
    </div>  
  </div>
</template>

<script>

export default {
  mounted() {
  },
  props: ['flg', 'pageurl', 'settlement_id', 'employee_pf_data'],

  data() {
    return {}
  },

}
</script>
